import { useMutation } from '@tanstack/react-query';
import { calculateEV } from '../data/evApi';
import { CalculateEVRequest, CalculateEVApiResult } from '../data/evTypes';
import { useAuth } from '../../../hooks/useAuth';

/**
 * React Query mutation for calculating EV with custom projections.
 */
export function useCalculateEVMutation() {
  const { getToken } = useAuth();

  return useMutation<CalculateEVApiResult, Error, CalculateEVRequest>({
    mutationFn: async (request: CalculateEVRequest) => {
      const accessToken = await getToken();
      return calculateEV(request, accessToken);
    },
  });
}
